import { FreeExportGate, type ExportGate } from './export-gate.ts';

/** The active export gate. Replace with a payment-backed gate when payments launch. */
export const exportGate: ExportGate = new FreeExportGate();
